import styled from 'styled-components';
import { PropsWithTheme } from '@rategravity/own-up-component-library';

export const BreadcrumbsContainer = styled.nav`
  li:not(:first-child)::before {
    content: '/';
    margin: 0 0.5rem;
    color: #00769b;
    align-items: end;
  }

  a {
    text-decoration: none;
    transition: color 0.2s;
  }
`;

export const BreadcrumbsList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const BreadcrumbItem = styled.li`
  display: flex;
  align-items: end;
`;

export const Link = styled.a`
  color: ${({ theme }: PropsWithTheme<{}>) => theme.underlineLinkColors.linkFontColor};
  text-decoration: none;
`;
